import { Link } from 'react-router-dom';
import type { AccessLevel, ModuleKey } from '@gty/common';

import { DEFAULT_ROUTE, moduleLabel } from '../app/module-registry';
import { Icon } from '../ui/icons';
import { Button, EmptyState } from '../ui/primitives';

export interface ForbiddenProps {
  module?: ModuleKey;
  requiredLevel?: AccessLevel;
}

/**
 * 403 view. Named plainly rather than softened ("Oops!") — the user needs to
 * know this is a permissions boundary, not a failure they can retry.
 */
export function Forbidden({ module, requiredLevel }: ForbiddenProps): JSX.Element {
  const what = module !== undefined ? moduleLabel(module) : 'this area';

  return (
    <EmptyState
      title="You don't have access"
      description={
        `Your role can't open ${what}` +
        (requiredLevel !== undefined ? ` (needs ${requiredLevel} access).` : '.') +
        ' Ask an Owner or Admin to change your permissions.'
      }
      action={
        <Link to={DEFAULT_ROUTE}>
          <Button variant="outline" icon={<Icon name="dashboard" size={15} />}>
            Back to dashboard
          </Button>
        </Link>
      }
    />
  );
}
